import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import { stopAndPrevent } from "../../utils/event.js";
import { between } from "../../utils/format.js";
import QIcon from "../icon/QIcon.js";
import SizeMixin from "../../mixins/size.js";
import FormMixin from "../../mixins/form.js";
import ListenersMixin from "../../mixins/listeners.js";
import cache from "../../utils/cache.js";
import { slot } from "../../utils/slot.js";
export default Vue.extend({
  name: 'QRating',
  mixins: [SizeMixin, FormMixin, ListenersMixin],
  props: {
    value: {
      type: Number,
      required: true
    },
    max: {
      type: [String, Number],
      default: 5
    },
    icon: [String, Array],
    iconHalf: [String, Array],
    iconSelected: [String, Array],
    color: [String, Array],
    colorHalf: [String, Array],
    colorSelected: [String, Array],
    noReset: Boolean,
    noDimming: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  data: function data() {
    return {
      mouseModel: 0
    };
  },
  computed: {
    editable: function editable() {
      return this.readonly !== true && this.disable !== true;
    },
    classes: function classes() {
      return "q-rating--".concat(this.editable === true ? '' : 'non-', "editable") + (this.noDimming === true ? ' q-rating--no-dimming' : '') + (this.disable === true ? ' disabled' : '') + (this.color !== void 0 && Array.isArray(this.color) === false ? " text-".concat(this.color) : '');
    },
    iconData: function iconData() {
      var iconLen = Array.isArray(this.icon) === true ? this.icon.length : 0,
          selIconLen = Array.isArray(this.iconSelected) === true ? this.iconSelected.length : 0,
          halfIconLen = Array.isArray(this.iconHalf) === true ? this.iconHalf.length : 0,
          colorLen = Array.isArray(this.color) === true ? this.color.length : 0,
          selColorLen = Array.isArray(this.colorSelected) === true ? this.colorSelected.length : 0,
          halfColorLen = Array.isArray(this.colorHalf) === true ? this.colorHalf.length : 0;
      return {
        iconLen: iconLen,
        icon: iconLen > 0 ? this.icon[iconLen - 1] : this.icon,
        selIconLen: selIconLen,
        selIcon: selIconLen > 0 ? this.iconSelected[selIconLen - 1] : this.iconSelected,
        halfIconLen: halfIconLen,
        halfIcon: halfIconLen > 0 ? this.iconHalf[selIconLen - 1] : this.iconHalf,
        colorLen: colorLen,
        color: colorLen > 0 ? this.color[colorLen - 1] : this.color,
        selColorLen: selColorLen,
        selColor: selColorLen > 0 ? this.colorSelected[selColorLen - 1] : this.colorSelected,
        halfColorLen: halfColorLen,
        halfColor: halfColorLen > 0 ? this.colorHalf[halfColorLen - 1] : this.colorHalf
      };
    },
    attrs: function attrs() {
      if (this.disable === true) {
        return {
          'aria-disabled': 'true'
        };
      }

      if (this.readonly === true) {
        return {
          'aria-readonly': 'true'
        };
      }
    }
  },
  methods: {
    __set: function __set(value) {
      if (this.editable === true) {
        var model = between(parseInt(value, 10), 1, parseInt(this.max, 10)),
            newVal = this.noReset !== true && this.value === model ? 0 : model;
        newVal !== this.value && this.$emit('input', newVal);
        this.mouseModel = 0;
      }
    },
    __setHoverValue: function __setHoverValue(value) {
      if (this.editable === true) {
        this.mouseModel = value;
      }
    },
    __keyup: function __keyup(e, i) {
      switch (e.keyCode) {
        case 13:
        case 32:
          this.__set(i);

          return stopAndPrevent(e);

        case 37: // LEFT ARROW

        case 40:
          // DOWN ARROW
          if (this.$refs["rt".concat(i - 1)]) {
            this.$refs["rt".concat(i - 1)].focus();
          }

          return stopAndPrevent(e);

        case 39: // RIGHT ARROW

        case 38:
          // UP ARROW
          if (this.$refs["rt".concat(i + 1)]) {
            this.$refs["rt".concat(i + 1)].focus();
          }

          return stopAndPrevent(e);
      }
    }
  },
  render: function render(h) {
    var _this = this;

    var child = [],
        tabindex = this.editable === true ? 0 : null,
        icons = this.iconData,
        ceil = Math.ceil(this.value);
    var halfIndex = this.iconHalf === void 0 || ceil === this.value ? -1 : ceil;

    var _loop = function _loop(i) {
      var active = _this.mouseModel === 0 && _this.value >= i || _this.mouseModel > 0 && _this.mouseModel >= i,
          half = halfIndex === i && _this.mouseModel < i,
          exSelected = _this.mouseModel > 0 && (half === true ? ceil : _this.value) >= i && _this.mouseModel < i,
          name = half === true ? i <= icons.halfIconLen ? _this.iconHalf[i - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i <= icons.selIconLen ? _this.iconSelected[i - 1] : icons.selIcon : i <= icons.iconLen ? _this.icon[i - 1] : icons.icon,
          color = half === true ? i <= icons.halfColorLen ? _this.colorHalf[i - 1] : icons.halfColor : icons.selColor !== void 0 && active === true ? i <= icons.selColorLen ? _this.colorSelected[i - 1] : icons.selColor : i <= icons.colorLen ? _this.color[i - 1] : icons.color;
      child.push(h(QIcon, {
        key: i,
        ref: "rt".concat(i),
        staticClass: 'q-rating__icon',
        class: _defineProperty({
          'q-rating__icon--active': active === true || half === true,
          'q-rating__icon--exselected': exSelected,
          'q-rating__icon--hovered': _this.mouseModel === i
        }, "text-".concat(color), color !== void 0),
        props: {
          name: name || _this.$q.iconSet.rating.icon
        },
        attrs: {
          tabindex: tabindex
        },
        on: cache(_this, 'i#' + i, {
          click: function click() {
            _this.__set(i);
          },
          mouseover: function mouseover() {
            _this.__setHoverValue(i);
          },
          mouseout: function mouseout() {
            _this.mouseModel = 0;
          },
          focus: function focus() {
            _this.__setHoverValue(i);
          },
          blur: function blur() {
            _this.mouseModel = 0;
          },
          keyup: function keyup(e) {
            _this.__keyup(e, i);
          }
        })
      }, slot(_this, "tip-".concat(i))));
    };

    for (var i = 1; i <= this.max; i++) {
      _loop(i);
    }

    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(child, 'push');
    }

    return h('div', {
      staticClass: 'q-rating row inline items-center',
      class: this.classes,
      style: this.sizeStyle,
      attrs: this.attrs,
      on: _objectSpread({}, this.qListeners)
    }, child);
  }
});